import Crud from '../views/VehicleType/Crud'
import Entity from '../views/VehicleType/Add'

let routes = {
    path: '/vehicle_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicle_types/add',
            name: 'NewVehicleType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Veículo',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Veículo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_types/edit/:id?',
            name: 'EditVehicleType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Veículo',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Veículo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_types',
            name: 'list-vehicle-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Veículos',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Veículos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
